import { SchoolLearningExperience } from "@interfaces/school"
import clsx from "clsx"
import { ExperienceMobileColumn, ExperienceWebColumn } from "./ExperienceColumn"
import { ProgramHeading } from "../general/ProgramHeading"

const PROCLASS_DESCRIPTION = {
  title: "Rise Learn & Play",
  description:
    "Kuasai technical dan soft skill dalam waktu singkat secara intensif. Belajar secara teori hingga praktik yang dibimbing langsung oleh tutor yang sudah expert di bidangnya, serta didukung dengan kurikulum yang disusun dan di-review oleh ahlinya.",
}

const DescriptionColumn = ({
  description,
  title,
  index,
}: {
  title: string
  description: string
  index: number
}) => {
  return (
    <div className={clsx("border border-new-grey", "sm:p-6 py-4 px-[18px]")}>
      <div className="font-semibold mb-1.5">
        {title} {index === 1 && <span className="text-red">*</span>}
      </div>
      <div className="text-black-48 text-sm">{description}</div>
      {index === 1 && (
        <div className="text-black-48 text-sm mt-1.5">
          <span className="text-red">*</span> khusus Get A Job Program & Refund Guarantee program
        </div>
      )}
    </div>
  )
}

export function ProgramExperience({
  experiences,
}: {
  experiences: SchoolLearningExperience[]
}) {
  if (!experiences || !experiences.length) {
    return <></>
  }

  return (
    <div className={clsx("relative mb-9")} id="experience1">
      <ProgramHeading
        id="experience"
        title="Learning Experience"
        subTitle={`Gimana Sistem Belajar di ProClass Harisenin.com?`}
      />

      <div className={clsx("grid sm:gap-9 sm:mb-9", "gap-[18px] mb-8")}>
        <DescriptionColumn {...PROCLASS_DESCRIPTION} index={0} />
      </div>

      <div className="sm-only:hidden">
        <ExperienceWebColumn experiences={experiences} />
      </div>

      <div className="sm:hidden">
        <ExperienceMobileColumn experiences={experiences} />
      </div>
    </div>
  )
}
